import { render } from "./SiteTopbar.vue?vue&type=template&id=2f87a9d8"
import script from "./SiteTopbar.vue?vue&type=script&lang=js"
export * from "./SiteTopbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__